// React
import React from "react";

// Libraries
import ScrollableAnchor from 'react-scrollable-anchor';

import './login.css';
import './features.css';

export const Features = () => {

    return (
        <ScrollableAnchor id={'features'}>
            <div className="section" id="section-2">
                <div className="section-title">Features</div>

                <div className="section-content">  

                    <div className="feature-row">

                        <div className="feature">

                            <div className="feature-icon">
                                <i className="icon-shield2"></i>
                            </div>

                            <div className="feature-content">

                                <div className="title">Security</div>
                                <div className="description" style={{marginTop:0}}>
                                    <div className="point">
                                        Yety doesn't hold any of your cryptocurrency.  You give us <b>read-only</b> access, which you can delete at any time.  In case of a data breach, you don't lose.
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="feature">

                            <div className="feature-icon">
                                <i className="icon-mobile2"></i>
                            </div>

                            <div className="feature-content">

                                <div className="title">Mobile</div>
                                <div className="description">
                                    <div className="point">
                                    Yety was built with an emphasis on mobile. No more pinching and zooming on the go. See what matters from the palm of your hand.
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div className="feature-row">

                        <div className="feature">

                            <div className="feature-icon">
                                <i className="icon-atom2"></i>
                            </div>

                            <div className="feature-content">

                                <div className="title">Professional Grade Analytics</div>
                                <div className="description">
                                    <div className="point">
                                        We have built these analytics for professional traders.  We know how important it is to provide accurate and detailed analysis.
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="feature">

                            <div className="feature-icon">
                                <i className="icon-people"></i>
                            </div>

                            <div className="feature-content">

                                <div className="title">Support and The Team</div>
                                <div className="description">
                                    <div className="point">
                                        Have a question, issue or suggestion? Speak directly with the Yety Team. We're not too busy to hear from you.
                                    </div>
                                    <div className="point contact-us">
                                        <div className='contact-button'><a href='mailto:accounts@yety.io'><i className="icon-paperplane text-size-xlarge"></i>Contact Us</a></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    
                    </div>

                </div>

            </div>
        </ScrollableAnchor>
    );

};


// WEBPACK FOOTER //
// ./src/Views/Login/Features.js